/** Tracks in-flight `api` requests for the global loading overlay. */

let pendingCount = 0;
let listener = null;

export function subscribeApiLoading(onChange) {
  listener = onChange;
  onChange(pendingCount);
  return () => {
    if (listener === onChange) listener = null;
  };
}

export function apiLoadingStart() {
  pendingCount += 1;
  listener?.(pendingCount);
}

export function apiLoadingEnd() {
  pendingCount = Math.max(0, pendingCount - 1);
  listener?.(pendingCount);
}

export function getApiLoadingCount() {
  return pendingCount;
}
